import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { AuthProvider, useAuth } from '../contexts/AuthContext';
import { DataProvider } from '../contexts/DataContext';
import Dashboard from '../pages/admin/Dashboard';
import EmailSignIn from '../pages/auth/emailAuth/EmailSignIn';
import EmailSignUp from '../pages/auth/emailAuth/EmailSignUp';
import MobileSignIn from '../pages/auth/mobileAuth/MobileSignIn';
import UserPage from '../pages/user/UserPage';
import PrivateRoute from './PrivateRoute';
import './AppPageStyles.css'
import { AppProvider, useAppContext } from '../contexts/AppContext';

function App() {

  const auth = useAuth();

  const FormSelector: React.FC<any> = (props: any) => {
    const [loading, setLoading] = useState(true);
    console.log(auth?.currentUserRole);
    useEffect(() => {
      if (loading) {
        const timer = setTimeout(() => {
          setLoading(false);
        }, 2000);
        return () => clearTimeout(timer);
      }
      // eslint-disable-next-line 
    }, []);

    const getElement = () => {
      switch (props.path) {
        case "/":
          return (auth?.currentUser && auth?.currentUserRole === "admin") ? <Redirect to='/admin' /> : <Redirect to='/u' />
        case "/admin":
          return (auth?.currentUser && auth?.currentUserRole === "admin") ? <Dashboard /> : <Redirect to='/signin' />
        default:
          return <></>
      }
    }

    return (<>
      {
        loading ? <p>Loading..</p> : getElement()
      }
    </>
    )
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Router>
        <AppProvider>
          <AuthProvider>
            <DataProvider>
              <Switch>
                <PrivateRoute exact path="/">
                  <FormSelector path="/" />
                </PrivateRoute>
                <PrivateRoute exact path="/admin" type="admin" >
                  <FormSelector path="/admin" />
                </PrivateRoute>
                <PrivateRoute path="/admin/:page" type="admin">
                  <FormSelector path="/admin" />
                </PrivateRoute>
                <Route path="/signin" component={EmailSignIn} />
                <Route path="/signup" component={EmailSignUp} />
                <Route path="/mobilesignin" component={MobileSignIn} />
                <PrivateRoute exact path="/u" component={UserPage} />
                <PrivateRoute path="/u/:page" component={UserPage} />
              </Switch>
            </DataProvider>
          </AuthProvider>
        </AppProvider>
      </Router>
    </MuiPickersUtilsProvider>
  )
}

export default App
